import { Breadcrumb } from "antd";
import { useEffect, useRef, useState } from "react";
import { RightOutlined } from "@ant-design/icons";
import "./index.less";

const HsBreadcrumb = ({ pathname }) => {
  const defaultMap = [
    {
      title: "首页",
      href: "/",
    },
  ];

  const routeMap = {
    "/": "首页",
    "/productor": "产品介绍",
    "/cookbook": "好侍菜谱",
    //"/business": "业务合作",
    "/newslist": "新闻中心"
  };

  const detailMap = {
    cookdetail: "/cookbook",
    prodetail: "/productor"
  };

  const simpleDetailMap = {
    newsdetail: "/newslist"
  };

  const [items, setItems] = useState(defaultMap);

  useEffect(() => {
    let item = items;
    const current = make(pathname);
    const key = Object.keys(detailMap).find((i) => pathname.includes(i));
    const simpleKey = Object.keys(simpleDetailMap).find((i) => pathname.includes(i));
    
    if (current.title) {
      item.length = 1;
      item.push(make(pathname));
      setItems([...item]);
    } else if (key) {
      item.length = 1;
      setTimeout(() => {
        const name = localStorage.getItem(key);
        item.push(make(detailMap[key]));
        item.push({
          title: name,
          href: pathname,
        });
        setItems([...item]);
      }, 700);
    } else if (simpleKey) {
      // 对于新闻详情页面，只显示到新闻中心，不显示具体标题
      item.length = 1;
      item.push(make(simpleDetailMap[simpleKey]));
      setItems([...item]);
    }
  }, [pathname]);

  const make = (pathname) => ({
    title: routeMap[pathname],
    href: pathname,
  });

  const separator = <RightOutlined style={{ fontSize: 16, margin: "0", color: "#333333" }} />;

  return <Breadcrumb className="HsBreadcrumb" separator={separator} items={items} />;
};

export default HsBreadcrumb;
